import { gql } from '@apollo/client';

export const VANITY_ITEM_OWNERSHIP_STATS = gql`
  query VanityItemOwnershipStats($category: VanityItemCategory!, $vanityItemIdPrefix: String!) {
    vanityItemOwnershipStats(category: $category, vanityItemIdPrefix: $vanityItemIdPrefix) {
      category
      vanityItemIdPrefix
      totalUsers
      activeLast30Days
      computedAt
    }
  }
`;
